import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

const STATUSES = [
  {
    value: "not_shot",
    label: "Not Shot",
    className: "bg-zinc-800 text-zinc-300 border-zinc-700",
  },
  {
    value: "in_progress",
    label: "In Progress",
    className: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  },
  {
    value: "completed",
    label: "Completed",
    className: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  },
];

export default function StatusBadge({ value, onChange, testId }) {
  const curr = STATUSES.find((s) => s.value === value) || STATUSES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium border rounded-full ${curr.className} hover:opacity-80 transition-opacity`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-current" />
          {curr.label}
          <ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-zinc-950 border-zinc-800 text-zinc-100"
      >
        {STATUSES.map((s) => (
          <DropdownMenuItem
            key={s.value}
            data-testid={`${testId}-opt-${s.value}`}
            onClick={() => onChange(s.value)}
            className="cursor-pointer focus:bg-zinc-900 focus:text-zinc-100"
          >
            <span
              className={`inline-block w-2 h-2 rounded-full mr-2 ${
                s.value === "completed"
                  ? "bg-emerald-500"
                  : s.value === "in_progress"
                    ? "bg-amber-500"
                    : "bg-zinc-600"
              }`}
            />
            {s.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
